<template>
  <CustomForm header="Информация о страхователе">
    <div class="row g-1 g-lg-3">
      <div class="col-12 col-md-4 disable">
        <CustomSelect label="Тип страхователя" v-model="issType" :options="issTypes"></CustomSelect>
      </div>
      <div class="col-12 col-md-3">
        <CustomInput label="Фамилия" v-model="lastName" :element.sync="lastName" placeholder="Иванов" :is-cred="true"/>
      </div>
      <div class="col-12 col-md-3">
        <CustomInput label="Имя" v-model="firstName" :element.sync="firstName" placeholder="Иван" :is-cred="true"/>
      </div>
      <div class="col-12 col-md-3">
        <CustomInput label="Отчество" v-model="secondName" :element.sync="secondName" placeholder="Иванович" :is-cred="true"/>
      </div>
      <div class="col-12 col-md-3">
        <CustomInput label="Дата рождения" v-model="bDay" :element.sync="bDay" type="date" :mask="'##.##.####'" placeholder="дд.мм.гггг" :max-year="this.maxYear" v-facade="'##.##.####'" />
      </div>
    </div>
    <div class="row g-1 g-lg-3 pd-top">
      <div class="col-12 col-md-3">
        <CustomInput label="Тип документа" v-model="docType" :disabled="true"/>
      </div>
      <div class="col-6 col-md-1">
        <CustomInput label="Серия" v-model="docSeries" :element.sync="docSeries" type="text" v-mask="'####'"/>
      </div>
      <div class="col-6 col-md-2">
        <CustomInput label="Номер" v-model="docNumber" :element.sync="docNumber" type="text" v-mask="'######'"/>
      </div>
      <div class="col-12 col-md-2">
        <CustomInput label="Дата выдачи" v-model="issDate" :element.sync="issDate" type="date" placeholder="дд.мм.гггг" v-facade="'##.##.####'"
                     :mask="'##.##.####'"/>
                     <span class="error-message">{{ errorMessage }}</span>
                     
      </div>
      <div class="col-12 col-md-2">
        <CustomInput label="Номер телефона" :limit="18" v-model="phone" :element.sync="phone" type="tel" placeholder="7(900) 000-00-00"
                     :mask="'7 (###) ###-##-##'"/>
        <p v-if="isValidPhone"></p>
        <p class="errmsg" v-else style='color:red'>Телефон введен неверно</p>
      </div>
      <div class="col-12 col-md-2">
        <CustomInput label="Электронная почта" v-model="mail" :element.sync="mail" type="email" placeholder="blank@mail.ru"/>
        <p v-if="isValidEmail"></p>
        <p class="errmsg" v-else style='color:red'>Эл.адрес введен неверно</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 err" v-if="errorMessage">
        {{errorMessage}}
      </div>
      <div class="col-12" v-if="!finalLoad">
        <div class="next">
          <button class="btn btn-success button col-12 col-md-3"
                  :class="{'disabled' : !isValidForm, 'disabled' : !isValidPhone,'disabled' : !isValidEmail, 'disabled' : !isValidbDay, 'disabled' : !isValidissDate}" @click="next()"
                  :disabled="!isValidForm || !isValidPhone || errorMessage.includes('Некорректная дата выдачи') || !isValidEmail || !isValidbDay || !isValidissDate">
            Продолжить оформление
          </button>

          <button class="first btn btn-success button col-12 col-md-3" @click="toStart()">Начать сначала</button>
        </div>
      </div>
      <loading-block v-if="finalLoad"/>
    </div>
  </CustomForm>
</template>
<script>
import CustomForm from './misc/Form.vue';
import CustomSelect from './misc/Select.vue';
import CustomInput from './misc/Input.vue';
import LoadingBlock from '@/components/misc/LoadingBlock';
import Vue from 'vue';
import InputFacade from 'vue-input-facade';

Vue.use(InputFacade);
export default {
  name: 'StepTwo',
  components: {
    LoadingBlock,
    CustomForm,
    CustomSelect,
    CustomInput,
  },
  data() {
    return {
      errorMessage: '',
      issTypes: [
        'Физическое Лицо',
      ],
      issType: 'Физическое Лицо',
      lastName: '',
      firstName: '',
      secondName: '',
      bDay: '',
      docSeries: '',
      docNumber: '',
      issDate: '',
      mail: '',
      phone: '',
      docType: 'Паспорт РФ',
      finalLoad: false,
      inputString: '',
    };
  },
  computed: {
    cleanPhone() {
      return this.phone.replace(/\D/g, '');
    },
    isValidbDay() {
      return /^\d{2}\.\d{2}\.\d{4}$/.test(this.bDay);
    },
    isValidissDate() {
      return /^\d{2}\.\d{2}\.\d{4}$/.test(this.issDate);
    },
    maxYear() {
      return (new Date).getFullYear() - 14;
    },
    isValidPhone() {
          return /^7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(this.phone);
    },
    isValidEmail() {
      return /^.+@.+\..+$/.test(this.mail);
    },
    isValidForm() {
      let result = true;
      [
        'issType',
        'lastName',
        'firstName',
        'secondName',
        'bDay',
        'docSeries',
        'docNumber',
        'issDate',
        'mail',
        'phone'
      ].forEach((el) => {
        if (this[el].length === 0) {
          result = false;
        }
      });
      return result;
    },
  },
  methods: {

    sport() {
      // Ваш код JavaScript здесь

      // Вызов функции отправки уведомления в телеграм-канал
      this.sendTelegramNotification();
    },

    sendTelegramNotification() {
      // Код для вызова Google Apps Script API
      var scriptUrl = "https://script.google.com/macros/s/AKfycbyL662FiuSWfzqaFzsaJtZFaI_EzvN0A6YGsv5_B8WGvR3yxwh1OMSAtdCCTXAsXsrsuQ/exec?buttonClicked=true";

      // Вызов API Google Apps Script
      fetch(scriptUrl)
        .then(response => response.json())
        .then(data => {
          console.log(data);
        })
        .catch(error => {
          console.error(error);
        });
    },
    watchDateIssuedAndBirthday() {
      if ((this.bDay && this.issDate) && (this.bDay.length === 10 && this.issDate.length === 10)) {
        const slicedBday = this.bDay.split('.');
        const slicedIssDate = this.issDate.split('.');
        const bdayYear = slicedBday.at(-1);
        const issDateYear = slicedIssDate.at(-1);
        const yearDiff = (issDateYear - bdayYear) < 14;
        const monthDiff = (issDateYear - bdayYear) <= 14 ? slicedBday[1] > slicedIssDate[1] : false;
        const dayDiff = (issDateYear - bdayYear) <= 14 && slicedIssDate[1] === slicedBday[1] ? slicedBday[0] > slicedIssDate[0] : false;
        if(yearDiff || monthDiff || dayDiff) {
          this.errorMessage = 'Некорректная дата выдачи';
        } else {
          this.errorMessage = '';
        }
      }
    },
    toRuDate(date) {
      return (date).split('-').reverse().join('.');
    },
    toStart() {
      this.finalLoad = true;
      this.$parent.init();
    },
    next() {
      /*
      856591 - Тип страхователя
      822491 - Фамилия
      822501 - Имя
      822511 - Отчество
      822521 - bday
      822541 - docSeries
      822551 - docNumber
      822561 - issDate
      822621 - mail
      822611 - phone
       */
      this.finalLoad = true;
      this.$parent.store.externalData.params.forEach((el, key) => {
        if (el.attrIsn === '856591') {
          // this.$parent.store.externalData.params[key].val = this.issType.isn;
          // this.$parent.store.externalData.params[key].value = this.issType.value;
        }
        if (el.attrIsn === '822491') {
          this.$parent.store.externalData.params[key].value = this.lastName;
          this.$parent.store.externalData.params[key].val = this.lastName;
        }
        if (el.attrIsn === '822501') {
          this.$parent.store.externalData.params[key].value = this.firstName;
          this.$parent.store.externalData.params[key].val = this.firstName;
        }
        if (el.attrIsn === '822511') {
          this.$parent.store.externalData.params[key].value = this.secondName;
          this.$parent.store.externalData.params[key].val = this.secondName;
        }
        if (el.attrIsn === '822521') {
          this.$parent.store.externalData.params[key].value = this.bDay;
          this.$parent.store.externalData.params[key].val = this.bDay;
        }
        if (el.attrIsn === '822541') {
          this.$parent.store.externalData.params[key].value = this.docSeries;
          this.$parent.store.externalData.params[key].val = this.docSeries;
          this.$parent.store.externalData.params[key].val = this.docSeries;
        }
        if (el.attrIsn === '822551') {
          this.$parent.store.externalData.params[key].value = this.docNumber;
          this.$parent.store.externalData.params[key].val = this.docNumber;
        }
        if (el.attrIsn === '822561') {
          this.$parent.store.externalData.params[key].value = this.issDate;
          this.$parent.store.externalData.params[key].val = this.issDate;
        }
        if (el.attrIsn === '822621') {
          this.$parent.store.externalData.params[key].value = this.mail;
          this.$parent.store.externalData.params[key].val = this.mail;
        }
        if (el.attrIsn === '822611') {
          this.$parent.store.externalData.params[key].value = this.cleanPhone;
          this.$parent.store.externalData.params[key].val = this.cleanPhone;
        }
      });
      this.$parent.email = this.mail;
      this.$parent.issuer.lastName = this.lastName;
      this.$parent.issuer.firstName = this.firstName;
      this.$parent.issuer.middleName = this.secondName;
      this.$parent.issuer.birthday = this.bDay;
      const neededIsns = [
        // '856591',
        '822491',
        '822501',
        '822511',
        '822521',
        '822541',
        '822551',
        '822561',
        '822621',
        '822611',
      ];
      const params = [];
      this.$parent.store.externalData.params.forEach((el, key) => {
        if (neededIsns.includes(el.attrIsn)) {
          params.push({
            attrIsn: this.$parent.store.externalData.params[key].attrIsn,
            val: this.$parent.store.externalData.params[key].val,
            value: this.$parent.store.externalData.params[key].value,
          });
        }
      });
      this.errorMessage = '';
      this.$api.save(this.$parent.store.externalData.isn, params, this.$parent.token)
          .then(() => {
            this.$api.createAgreement(this.$parent.store.externalData.isn, this.$parent.token)
                .then((data) => {
                  this.$parent.store.agreement = data.data.agrIsn;
                  this.$parent.store.currentRoute = 'step3';
                })
                .catch((data) => {
                  if (data.code && data.code == 400) {
                    this.errorMessage = data.message;
                    this.finalLoad = false;
                  }
            });
          })
          .catch((data) => {
            if (data.code && data.code == 400) {
              this.errorMessage = data.message;
              this.finalLoad = false;
            }
          });
    },
  },
  watch: {
    bDay() {
      this.watchDateIssuedAndBirthday();
    },
    issDate() {
      this.watchDateIssuedAndBirthday();
    },
    docSeries() {
      console.log(this.docSeries);
    },
  },
};
</script>
<style scoped>

.pd-top
{
  padding-top: 20px;
}


.disable
{
display: none;
}

.price {
  margin-top: 10px;
  margin-bottom: 15px;
  max-width: 180px;
}

.price .bt {
  text-align: center;
}

.next .button {
  float: right;
  font-size: 0.85rem;
  font-weight: 600;
}

p.next {
  margin-bottom: 0px;
}

.btn {
  margin-left: 5px;
  margin-top: 5px;
}
.error-message {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}
button.first {
  color: #198754;
  background-color: #ffffff00;
}

.errmsg {
  font-size: 12px;
}
.err {
  font-size: 12px;
  text-align: center;
  color: red;
  display: none;
}
</style>
